import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import devices from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const Header = styled('header')`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }

  .header {
    font-family: ${FONT_FAMILY.hellix.regular};
    text-align: left;
    font-size: 30px;
    color: ${COLORS.black};
    text-transform: capitalize;
  }

  .sub-header {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 18px;
    line-height: 1.94;
    color: ${COLORS.textLightGrey};
  }

  .new-kyc-flow {
    display: flex;
    justify-content: space-between;
    padding: 15px 30px;
    border: 1px solid ${COLORS.borderGrey};
    background-color: ${COLORS.brandSecondary};
    max-width: 503px;
    width: 100%;
    border-radius: 15px;
    box-shadow: 3px 4px 10px rgba(0, 0, 0, 0.07);
    cursor: pointer;
    margin-right: 25px;
    div {
      flex: 2;
      h1 {
        font-family: ${FONT_FAMILY.hellix.bold};
        color: #000;
        font-size: 28px;
        text-align: left;
        margin-bottom: 5px;
      }
      p {
        text-align: left;
        font-size: 18px;
        color: #333;
        font-family: ${FONT_FAMILY.hellix.regular};
      }
    }
  }

  @media ${devices.mobile} {
    .header {
      font-family: ${FONT_FAMILY.hellix.regular};
      text-align: left;
      font-size: 23px;
      color: ${COLORS.black};
      text-transform: capitalize;
    }

    .sub-header {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 14px;
      line-height: 1.94;
      color: #969cc1;
    }
    .new-kyc-flow {
      margin-top: 20px;
      border-radius: 4px;
      box-shadow: none;
      padding: 10px 15px;
      div {
        h1 {
          font-size: 16px;
        }
        p {
          font-size: 14px;
        }
      }
    }
  }
`;

export default Header;
